export const de = {
  // Navigation (German)
  explore: 'Entdecken',
  search: 'Suchen',
  create: 'Beitrag erstellen',
  messages: 'Nachrichten',
  notifications: 'Benachrichtigungen',
  settings: 'Einstellungen',
  profile: 'Profil',
  logout: 'Abmelden',
  home: 'Startseite',
  
  // Authentication
  signin: 'Anmelden',
  signup: 'Registrieren',
  login: 'Anmelden',
  register: 'Registrieren',
  email: 'E-Mail',
  password: 'Passwort',
  confirmPassword: 'Passwort bestätigen',
  firstName: 'Vorname',
  lastName: 'Nachname',
  forgotPassword: 'Passwort vergessen?',
  alreadyHaveAccount: 'Bereits ein Konto? Anmelden',
  dontHaveAccount: 'Kein Konto? Registrieren',
  
  // Posts & Content
  recent: 'Neueste',
  trending: 'Trending',
  popular: 'Beliebt',
  like: 'Gefällt mir',
  likes: 'Gefällt mir',
  comment: 'Kommentar',
  comments: 'Kommentare',
  share: 'Teilen',
  delete: 'Löschen',
  edit: 'Bearbeiten',
  post: 'Beitrag',
  posts: 'Beiträge',
  title: 'Titel',
  content: 'Inhalt',
  tags: 'Tags',
  noBlogsFound: 'Keine Blogs gefunden. Versuchen Sie etwas anderes zu suchen oder erstellen Sie den ersten!',
  
  // AI Assistant
  quickActions: 'Schnelle Aktionen',
  writeCaption: 'BILDUNTERSCHRIFT SCHREIBEN',
  suggestTopics: 'THEMEN VORSCHLAGEN',
  improveContent: 'INHALT VERBESSERN',
  creativeIdeas: 'KREATIVE IDEEN',
  clearChat: 'CHAT LÖSCHEN',
  aiWritingAssistant: 'KI-Schreibassistent',
  poweredByGroq: 'Unterstützt von GROQ AI',
  aiGreeting: 'Hallo! Ich bin Ihr KI-Schreibassistent. Ich kann Ihnen helfen, ansprechende Inhalte zu erstellen, Bildunterschriften zu schreiben, Beitragsthemen vorzuschlagen und Ihr Schreiben zu verbessern. Woran möchten Sie heute arbeiten?',
  askMeToHelp: 'Bitten Sie mich um Hilfe bei Inhalten, Bildunterschriften, Themen oder Schreiben...',
  aiThinking: 'KI denkt nach...',
  
  // Chat & Messages
  chat: 'Chat',
  noConversationsYet: 'Noch keine Unterhaltungen',
  ideafluxChat: 'IdeaFlux Chat',
  typeMessage: 'Nachricht eingeben...',
  sendMessage: 'Nachricht senden',
  connectingToChat: 'Verbindung zum Chat...',
  
  // Notifications
  noNotificationsYet: 'Noch keine Benachrichtigungen.',
  markAllRead: 'Alle als gelesen markieren',
  clearAll: 'Alle löschen',
  
  // Settings
  accountSettings: 'Kontoeinstellungen',
  displayName: 'Anzeigename',
  emailAddress: 'E-Mail-Adresse',
  languagePreference: 'Spracheinstellung',
  privacySecurity: 'Datenschutz & Sicherheit',
  notificationPreferences: 'Benachrichtigungseinstellungen',
  allowDirectMessages: 'Direktnachrichten erlauben',
  letOthersMessage: 'Anderen Benutzern erlauben, Ihnen private Nachrichten zu senden',
  likesOnPosts: 'Gefällt mir bei Beiträgen',
  commentsOnPosts: 'Kommentare zu Beiträgen',
  newFollowers: 'Neue Follower',
  mentions: 'Erwähnungen',
  save: 'Speichern',
  deleteAccount: 'Konto löschen',
  
  // Notification descriptions
  getNotifiedWhenSomeone: 'Benachrichtigung erhalten, wenn jemand',
  likesYourPosts: 'Ihre Beiträge mag',
  commentsOnYourPosts: 'Ihre Beiträge kommentiert',
  followsYou: 'Ihnen folgt',
  mentionsYou: 'Sie erwähnt',
  chooseNotifications: 'Wählen Sie, welche Benachrichtigungen Sie erhalten möchten',
  controlWhoInteracts: 'Kontrollieren Sie, wer mit Ihnen interagieren kann',
  manageAccountInfo: 'Verwalten Sie Ihre Kontoinformationen und Einstellungen',
  emailCannotBeChanged: 'E-Mail kann aus Sicherheitsgründen nicht geändert werden',
  
  // Common
  loading: 'Wird geladen...',
  cancel: 'Abbrechen',
  update: 'Aktualisieren',
  submit: 'Senden',
  back: 'Zurück',
  next: 'Weiter',
  previous: 'Vorherige',
  online: 'Online',
  offline: 'Offline',
  
  // Profile
  editProfile: 'PROFIL BEARBEITEN',
  noBioYet: 'Noch keine Bio.',
  followers: 'Follower',
  following: 'Folge ich',
  recentActivity: 'Letzte Aktivität',
  noPostsYet: 'Noch keine Beiträge',
  shareFirstPost: 'Teile deinen ersten Beitrag!',
  bio: 'Bio',
  dateOfBirth: 'Geburtsdatum',
  follow: 'Folgen',
  unfollow: 'Entfolgen',
  
  // Search
  discover: 'Entdecken',
  findPeopleStories: 'Finde Menschen, Geschichten und Ideen, die dir wichtig sind',
  searchByName: 'Nach Name, Titel oder #Tag suchen...',
  searchResults: 'Suchergebnisse',
  noResultsFound: 'Keine Ergebnisse gefunden',
  peopleFound: 'Personen gefunden',
  
  // Settings - Additional keys
  enterDisplayName: 'Geben Sie Ihren Anzeigenamen ein',
  saving: 'Speichern...',
  confirmDeleteAccount: 'Sind Sie sicher, dass Sie Ihr Konto löschen möchten? Dies kann nicht rückgängig gemacht werden.',
  accountDeletedSuccessfully: 'Konto erfolgreich gelöscht.',
  errorDeletingAccount: 'Fehler beim Löschen des Kontos. Bitte versuchen Sie es erneut.',
  settingsSavedSuccessfully: 'Einstellungen erfolgreich gespeichert!',
  failedToSaveSettings: 'Fehler beim Speichern der Einstellungen. Bitte versuchen Sie es erneut.',
  
  // Form component
  pleaseSignInToCreate: 'Bitte melden Sie sich an, um einen Beitrag zu erstellen.',
  titleRequired: 'Titel ist erforderlich, um einen Beitrag zu veröffentlichen.',
  contentRequired: 'Story-Inhalt ist erforderlich, um einen Beitrag zu veröffentlichen.',
  contentTooShort: 'Story-Inhalt muss mindestens 10 Zeichen lang sein.',
  postUpdatedSuccessfully: 'Beitrag erfolgreich aktualisiert!',
  postPublishedSuccessfully: 'Beitrag erfolgreich veröffentlicht!',
  pleaseSignInToCreateBlogs: 'Bitte melden Sie sich an, um Ihre eigenen IdeaFlux-Blogs zu erstellen.',
  enterEngagingTitle: 'Geben Sie einen ansprechenden Titel ein...',
  story: 'Geschichte',
  writeYourMasterpiece: 'Schreiben Sie Ihr Meisterwerk...',
  addTags: 'Tags hinzufügen...',
  add: 'Hinzufügen',
  publishPost: 'Beitrag veröffentlichen',
  
  // Post component
  linkCopiedToClipboard: 'Link in die Zwischenablage kopiert! Teilen-Zähler aktualisiert.',
  youAndOthers: 'Sie und {{count}} andere',
  unknownUser: 'Unbekannter Benutzer',
  noImage: 'Kein Bild',
  deletePost: 'Beitrag löschen',
  confirmDeletePost: 'Sind Sie sicher, dass Sie diesen Beitrag löschen möchten?',
};